// global.BaseUrl = 'https://foodweb-quokka.ksoftpl.com/the-quay/public/api';
// global.AssetsUrl = 'https://foodweb-quokka.ksoftpl.com/the-quay/public';


global.BaseUrl = 'https://admin.foodweb-quokka.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-quokka.ksoftpl.com';

